export default "__VITE_ASSET__09985df6__"